export default __webpack_public_path__ + "static/national-yards-desktop-81365a488f6054b9c835665065b9e033.svg";